import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './Lasers.module.css'; // Создадим этот файл стилей позже
import Banner from '../sections/Banner/Banner';
import Cards from '../../../components/CardsUI/Cards/Cards';
import Table from '../sections/Table/Table';
import ServicesDescription from '../../../components/EntToEndUI/ServicesDescription/ServicesDescription';
import { PhoneLineIcon, FileIcon, DeliveryIcon } from '../../../components/Other/Icons/Icons';
import RequestForm from '../../../components/EntToEndUI/RequestForm/RequestForm';
import PageTitle from '../../../components/Other/PageTitle/PageTitle';

const Lasers = () => {
  const serviceType = 'lasers'
  const { t } = useTranslation();
  const cards = [
    {
      title: 'ЛАЗЕРНАЯ РЕЗКА МЕТАЛЛОВ И СПЛАВОВ',
      description: 'Обработка металлов и сплавов различных видов лазером, от простой перфоррации до сложных форм для производства деталей.',
      price: 'от 12 р./лист',
      image: '/images/cards/lasers/2.png',
    },
    {
      title: 'ЛАЗЕРНАЯ РЕЗКА ТРУБ',
      description: 'Высокоточная резка трубного профиля диаметром от 10 мм до 230 мм и длиной до 6500 мм с точностью позиционирования до ±0,1 мм.',
      price: 'от 120 р./отрез',
      image: '/images/cards/lasers/3.png',
    },
    {
      title: 'ГИБКА ЛИСТОВОГО МЕТАЛЛА И ПРОФИЛЯ',
      description: 'Обработка стали, черного и цветного проката - от формирования уголков до производства нестандартных элементов.',
      price: 'от 37,5 р/гиб',
      image: '/images/cards/lasers/1.png',
    },
    {
      title: 'КОНТАКТНАЯ СВАРКА',
      description: 'Обработка черных и цветных металлов для надежного и прочного соединения путем нагрева и пластической деформации элемнтов.',
      price: 'ОТ 12,5 р./точка',
      image: '/images/cards/lasers/4.png',
    },
    {
      title: 'АРГОННО-ДУГОВАЯ И ПОЛУАВТОМАТИЧЕСКАЯ СВАРКА',
      description: 'Аргонно-дуговая и полуавтоматическая сварка в среде защищенных газов. По вашим чертежам изготовим детали и корпусные изделия из алюминия, нержавеющей стали и других материалов.',
      price: 'ОТ 15 р./см',
      image: '/images/cards/lasers/5.png',
    },
    {
      title: 'ПОРОШКОВАЯ ОКРАСКА МЕТАЛЛИЧЕСКИХ ИЗДЕЛИЙ',
      description: 'Защита металла от негативного воздействия окружающей среды - ударопрочное покрытие и антикоррозийными свойствами.',
      price: 'Индивидуальный рассчет',
      image: '/images/cards/lasers/6.png',
    },
    {
      title: 'ПРОИЗВОДСТВО КОРПУСНЫХ ИЗДЕЛИЙ',
      description: 'Изготовление плоских и объемных деталей различной формы и размеры по техническому заданию Заказчика.',
      price: 'Индивидуальный рассчет',
      image: '/images/cards/lasers/7.png',
    },
  ];

  const steelPriceData = Array.from({ length: 10 }, (_, i) => ({
    'Толщина, мм': (i * 0.5 + 0.5).toFixed(1),
    'До 100 м, руб': Math.round(45 + i * 5),
    'От 101 до 500 м, руб': Math.round(31.25 + i * 3.5),
    'Свыше 501 м, руб': Math.round(25 + i * 2.5),
    'Стоимость врезки, руб': (0.625 + i * 0.125).toFixed(3),
    'Свыше 3000 м, руб': Math.round(20 + i * 2)
  }));

  const zincSteelPriceData = [
    {
      'Толщина, мм': 0.5,
      'До 100 м, руб': 46.25,
      'От 101 до 500 м, руб': 31.25,
      'Свыше 501 м, руб': 25,
      'Стоимость врезки, руб': 0.625,
      'Свыше 3000 м, руб': 21.25
    },
    {
      'Толщина, мм': 0.8,
      'До 100 м, руб': 47.5,
      'От 101 до 500 м, руб': 31.25,
      'Свыше 501 м, руб': 26.25,
      'Стоимость врезки, руб': 0.625,
      'Свыше 3000 м, руб': 21.25
    },
    {
      'Толщина, мм': 1,
      'До 100 м, руб': 47.5,
      'От 101 до 500 м, руб': 32.5,
      'Свыше 501 м, руб': 26.25,
      'Стоимость врезки, руб': 0.625,
      'Свыше 3000 м, руб': 22.5
    },
    {
      'Толщина, мм': 1.5,
      'До 100 м, руб': 50,
      'От 101 до 500 м, руб': 32.5,
      'Свыше 501 м, руб': 30,
      'Стоимость врезки, руб': 0.625,
      'Свыше 3000 м, руб': 23.75
    },
    {
      'Толщина, мм': 2,
      'До 100 м, руб': 52.5,
      'От 101 до 500 м, руб': 40,
      'Свыше 501 м, руб': 32.5,
      'Стоимость врезки, руб': 0.625,
      'Свыше 3000 м, руб': 26.25
    },
    {
      'Толщина, мм': 2.5,
      'До 100 м, руб': 57.5,
      'От 101 до 500 м, руб': 45,
      'Свыше 501 м, руб': 35,
      'Стоимость врезки, руб': 0.625,
      'Свыше 3000 м, руб': 30
    },
    {
      'Толщина, мм': 3,
      'До 100 м, руб': 87.5,
      'От 101 до 500 м, руб': 75,
      'Свыше 501 м, руб': 57.5,
      'Стоимость врезки, руб': 1.25,
      'Свыше 3000 м, руб': 38.75
    }
  ];

  const items = [
    {
      icon: <PhoneLineIcon />,
      description: t('services.lasers.info.phone')
    },
    {
      icon: <FileIcon />,
      description: t('services.lasers.info.file')
    },
    {
      icon: <DeliveryIcon />,
      description: t('services.lasers.info.delivery')
    }
  ];

  return (
    <div className="service-page">
      <PageTitle title={t('services.lasers.title')} />
      <Banner serviceType={serviceType} Image={'/images/cards/lasers/lasers.png'}/>
      <Cards cards={cards} maxCardTitleHeight={'54px'}/>
      <Table serviceType={serviceType} steelPriceData={steelPriceData} zincSteelPriceData={zincSteelPriceData}/>
      <ServicesDescription items={items} />
      <RequestForm />
    </div>
  );
};

export default Lasers; 